module.exports = __webpack_public_path__ + "img/example-digital-dashboard-kpi.057d4207.png";